import { inject, Injector } from '@angular/core';
import {
	FiltersConfig,
	FilterTypeEnum,
} from '../../../../shared/models/filters-config';
import { FEATURES } from '../../../../core/features/features';
import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';
import { VehicleRoadWorthyChecksService } from '../vehicle-road-worthy-checks.service';
import { VEHICLE_ROAD_WORTHY_CHECK_STATUSES } from '../translations/vehicle-road-worthy-checks-select-items';
import { SEARCHABLE_STRATEGY_TOKEN } from '../../../../shared/tokens/searchable-strategy.token';
import { TagSearchStrategy } from '../../tags/config/tag-searchable-strategy';
import { VehicleSearchStrategy } from '../../vehicles/config/vehicle-searchable-strategy';

export function getVehicleRoadWorthyCheckFilters(): FiltersConfig[] {
	const service = inject(VehicleRoadWorthyChecksService);
	const injector = inject(Injector);
	return [
		{
			title: 'road-worthy-checks|filter|statuses',
			options: VEHICLE_ROAD_WORTHY_CHECK_STATUSES,
			type: FilterTypeEnum.MULTI,
			selected$: service.vehicleRoadWorthyChecksFilters.statuses$,
		},
		...(FEATURES.tags
			? [
					{
						title: 'road-worthy-checks|filter|tags',
						type: FilterTypeEnum.SEARCHABLE,
						module: ModulesEnum.TAGS,
						selected$: service.vehicleRoadWorthyChecksFilters.tags$,
						injector: Injector.create({
							providers: [
								{
									provide: SEARCHABLE_STRATEGY_TOKEN,
									useClass: TagSearchStrategy,
								},
							],
							parent: injector,
						}),
					},
				]
			: []),
		...(FEATURES.vehicles
			? [
					{
						title: 'road-worthy-checks|filter|vehicles',
						type: FilterTypeEnum.SEARCHABLE,
						module: ModulesEnum.VEHICLES,
						selected$: service.vehicleRoadWorthyChecksFilters.vehicles$,
						injector: Injector.create({
							providers: [
								{
									provide: SEARCHABLE_STRATEGY_TOKEN,
									useClass: VehicleSearchStrategy,
								},
							],
							parent: injector,
						}),
					},
				]
			: []),
	];
}
